import { CallIcon } from 'components/icons/CallIcon';
import { CancelCallIcon } from 'components/icons/CancelCallIcon';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSpeechRecognition } from 'react-speech-kit';
import { setCallBot } from 'store/actions';
import './styles.scss';

const ReactSpeechKit = ({ sendToWebSocket, isAudioPlaying, setIsLoading }) => {
  const [lang] = useState('vi-VN');
  const [value, setValue] = useState('');
  const [isListening, setIsListening] = useState(false);
  const isListeningRef = useRef(false);

  const dispatch = useDispatch();

  const { listen, stop } = useSpeechRecognition({
    onResult: (result) => {
      setValue(result);
      console.log(isListeningRef.current);
    },
    onEnd: (result) => {
      console.log(result);
    },
  });

  useEffect(() => {
    if (isAudioPlaying) stop();
    else {
      listen({ lang });
    }
  }, [isAudioPlaying, lang, listen, stop]);

  useEffect(() => {
    if (!value) return;

    const timeoutId = setTimeout(() => {
      console.log('send', value);
      isListeningRef.current = false;
      sendToWebSocket(value);
      setIsLoading();
      stop();
    }, 1000);

    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const startListening = () => {
    setIsListening(true);
    isListeningRef.current = true;
    listen({ lang }); // vẫn luôn hoạt động
  };

  const stopListening = () => {
    setIsListening(false);
    stop();
  };

  const handleListenToggle = () => {
    if (isListening) {
      stopListening();
      dispatch(setCallBot(false));
    } else {
      dispatch(setCallBot(true));
      startListening();
    }
  };

  return (
    <div className="call_bot_btn">
      <button
        onClick={handleListenToggle}
        style={{ backgroundColor: isListening ? 'red' : '#3aa1d8' }}
        title={isAudioPlaying ? 'Đang phát âm thanh, chờ để nói' : ''}
      >
        {isListening ? <CancelCallIcon /> : <CallIcon />}
      </button>
    </div>
  );
};

export default ReactSpeechKit;
